import { useMutation, useQueryClient } from '@tanstack/react-query';
import { importTables } from '../../../../store/Restaurant/api';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

export const useImportTables = () => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    return useMutation(
        ['importTables'],
        ({ restaurant_id, integration_id }) =>
            importTables({
                restaurant_id,
                integration_id,
            }),
        {
            onSuccess: async (_, { restaurant_id }) => {
                await queryClient.invalidateQueries(['tables', restaurant_id]);
                toast.success(t('Tables successfully imported'));
            },
            onError: (error) => {
                toast.error(error.response?.data?.message);
            },
        }
    );
};
